import ApiKeySetup from "@/components/setup/ApiKeySetup.vue";

export default {
  path: "/config/apikey",
  name: "ApiKeySetup",
  component: ApiKeySetup,
  meta: {
    breadcrumb: "apikey"
  }
};
